import { render, staticRenderFns } from "./AdminBoxesElement.vue?vue&type=template&id=292b536e&scoped=true"
import script from "./AdminBoxesElement.vue?vue&type=script&lang=js"
export * from "./AdminBoxesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminBoxesElement.vue?vue&type=style&index=0&id=292b536e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292b536e",
  null
  
)

export default component.exports